import api from './api';

export const getHosts = async () => {
  const response = await api.get('/hosts');
  return response.data.data;
};

export const getHost = async (id) => {
  const response = await api.get(`/hosts/${id}`);
  return response.data.data;
};

export const createHost = async (hostData) => {
  const response = await api.post('/hosts', hostData);
  return response.data.data;
};

export const updateHost = async (id, hostData) => {
  const response = await api.put(`/hosts/${id}`, hostData);
  return response.data.data;
};

export const deleteHost = async (id) => {
  await api.delete(`/hosts/${id}`);
};